import React from 'react';
import type { SEOData } from 'cards/seo/types';
import { NextSEOHeader } from '../common/NextSEOHeader';

interface CardListingSEOHeaderProps {
  seoData: SEOData;
  imageUrl?: string;
}

export const CardListingSEOHeader: React.FC<CardListingSEOHeaderProps> = ({
  seoData,
  imageUrl,
}) => {
  const { title, description, canonical } = seoData;

  return (
    <NextSEOHeader
      title={title}
      description={description}
      canonical={canonical}
      imageUrl={imageUrl}
    />
  );
};
